import {
  CLEANUP_DISCOVER_CATEGORY_DETAILS,
  CLEANUP_DISCOVERY_CATEGORIES,
  GET_DISCOVERY_CATEGORIES,
  GET_DISCOVERY_CATEGORIES_FAILED,
  GET_DISCOVERY_CATEGORIES_SUCCESS,
  GET_DISCOVERY_CATEGORY_DETAILS,
  GET_DISCOVERY_CATEGORY_DETAILS_FAILED,
  GET_DISCOVERY_CATEGORY_DETAILS_SUCCESS,
} from './actionTypes';

// actionGetDiscoveryCategories
export const actionGetDiscoveryCategories = (payload) => ({
  payload,
  type: GET_DISCOVERY_CATEGORIES,
});

export const actionGetDiscoveryCategoriesSuccess = (payload) => ({
  payload,
  type: GET_DISCOVERY_CATEGORIES_SUCCESS,
});

export const actionGetDiscoveryCategoriesFailed = () => ({
  type: GET_DISCOVERY_CATEGORIES_FAILED,
});

export const actionCleanupDiscoveryCategories = () => ({
  type: CLEANUP_DISCOVERY_CATEGORIES,
});

// actionGetDiscoveryCategoriesDetails
export const actionGetDiscoveryCategoryDetails = (payload) => ({
  payload,
  type: GET_DISCOVERY_CATEGORY_DETAILS,
});

export const actionGetDiscoveryCategoryDetailsSuccess = (payload) => ({
  payload,
  type: GET_DISCOVERY_CATEGORY_DETAILS_SUCCESS,
});

export const actionGetDiscoveryCategoryDetailsFailed = () => ({
  type: GET_DISCOVERY_CATEGORY_DETAILS_FAILED,
});

export const actionCleanupDiscoverCategoryDetails = () => ({
  type: CLEANUP_DISCOVER_CATEGORY_DETAILS,
});
